module.exports = __webpack_public_path__ + "img/5.afa9cbf7.jpg";